import drawRect from './drawRect'
import inView from './inView'
import getSpaceRadius from './getSpaceRadius'

const drawBackground = ({ x, y, r, context, selected, fill }) => {
  drawRect({
    x: x - r,
    y: y - r,
    w: r * 2,
    h: r * 2,
    fillStyle: fill,
    context,
  })

  if (selected) {
    drawRect({
      x: x - 1.2 * r,
      y: y - 1.2 * r,
      w: r * 2.4,
      h: r * 2.4,
      strokeStyle: '#1B4BC5',
      lineWidth: Math.min(r / 2.2, 4),
      context,
    })
  }
}

const drawDeviceIcon = ({ x, y, r, fontSize, context }) => {
  const text = '\uf10a'
  context.font = `${1.5 * r}px 'Font Awesome 5 Pro'`
  context.fillStyle = 'white'
  context.textBaseline = 'middle'
  const w = context.measureText(text).width
  context.fillText(text, x - w / 2, y)
}

const Pin = ({
  device,
  dx,
  dy,
  maxScale,
  xScale,
  yScale,
  rScale,
  context,
  transform: t,
  screen,
  filtered,
  selected,
  fontSize,
  preview,
}) => {
  const x = dx * t.k + xScale(device.map.x)
  const y = dy * t.k + yScale(device.map.y)
  const r = getSpaceRadius({
    space: { w: device.map.w < 10 ? 10 : device.map.w },
    k: t.k,
    rScale,
    filtered,
    maxScale,
  })

  if (t.k >= 3 && !inView({ x, y, screen })) {
    return
  }

  context.globalAlpha = 1

  if (preview) {
    context.globalAlpha = 0.5
  }

  drawBackground({
    context,
    x,
    y,
    r,
    selected,
    fill: 'rgb(90, 97, 107)',
  })

  drawDeviceIcon({
    context,
    x,
    y,
    r,
    fontSize,
  })

  context.globalAlpha = 1
}

export default Pin
